import React from "react";

const EnergyHero = ({ className, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 1080 1080"
      className={className}
    >
      <path
        className="a"
        d="M539.3849,1030.42a10.6718,10.6718,0,0,1-4.1165-.8245c-1.0708-.4467-108.32-45.3917-214.4356-105.9716-145.2011-82.8907-219.3453-154.7512-220.37-213.5819C96.73,496.2267,100.4229,77.67,100.46,73.4675a10.6875,10.6875,0,0,1,10.7942-10.5917L967.728,65.595a10.6889,10.6889,0,0,1,10.5813,10.6022c.0334,4.2041,3.2878,428.1977-.0021,608.205-2.5759,141.02-416.7557,336.7458-434.3863,345.0079A10.6969,10.6969,0,0,1,539.3849,1030.42ZM121.7441,84.3578c-.549,66.9613-3.3024,430.9483.09,625.313,1.768,101.373,297.606,247.8579,417.3005,298.3659C658.8393,951.3686,955.0217,788.802,956.9359,684.01c2.9913-163.721.5594-530.9109.0772-597.1436Z"
      />
      <rect
        className="a"
        x="209.7448"
        y="170.4088"
        width="659.2801"
        height="21.3755"
      />
      <path
        className="a"
        d="M503.3638,867.4384a10.6848,10.6848,0,0,1-10.6857-10.6878V611.3414H357.2463a10.688,10.688,0,0,1-8.6817-16.923L582.4887,268.7007a10.6882,10.6882,0,0,1,19.37,6.2352V528.9914H737.9538a10.6872,10.6872,0,0,1,8.5919,17.044L511.9578,863.1069A10.6891,10.6891,0,0,1,503.3638,867.4384ZM378.0812,589.9659h117.081a18.9132,18.9132,0,0,1,18.8914,18.8914V824.3346L716.7515,550.3669H599.5954a19.1352,19.1352,0,0,1-19.1128-19.1148V308.1389Z"
      />
    </svg>
  );
};

export default EnergyHero;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Icons/EnergyHero.icon.js